exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3atqDI76odR1xE1P9rRAqH{margin-top:8px}", ""]);

// exports
exports.locals = {
	"applyParameter": "_3atqDI76odR1xE1P9rRAqH"
};